import { TCreateMaintenanceBlankDTO } from '@/pages/Processes/Maintenance/maintenance.types.ts'
import { Fragment } from 'react'
import TrashButton from '@/shared/Buttons/TrashButton'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import TextArea from '@/shared/Inputs/TextArea'
import SeparateLine from '@/shared/Forms/SeparateLine'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import MDMDataTypeDropdown from '@/pages/MDM/components/MDMDataTypeDropdown'

interface IProps {
  blank: TCreateMaintenanceBlankDTO
  onChange: (val: any, name: string) => void
  onCreateField: () => void
  onUpdateField: (index: number, val: any, key: string) => void
  onDeleteField: (index: number) => void
}

const MaintenanceBlankForm = (props: IProps) => {
  const renderBlankFields = () => {
    return props.blank.fields.map((f, index) => (
      <Fragment key={index}>
        <div className="flex-lines gap16">
          <div className="inline-flex-gap gap16 flex-space-between width100">
            <h3>Поле {index + 1}</h3>
            <TrashButton onClick={() => props.onDeleteField(index)} />
          </div>
          <FormField label="Наименование" required={true}>
            <TextInput
              value={f.name}
              name="name"
              onChange={(val, name) => props.onUpdateField(index, val, name)}
              placeHolder="Введите наименование"
            />
          </FormField>
          <FormField label="Тип данных" required={true}>
            <MDMDataTypeDropdown
              allowUnit={true}
              value={f}
              onChange={(val) => {
                props.onUpdateField(index, val.type, 'type')
                props.onUpdateField(index, val.typeEnumId, 'typeEnumId')
                props.onUpdateField(index, val.typeUnitId, 'typeUnitId')
              }}
            />
          </FormField>
          <FormField label="Содержание работ">
            <TextArea
              value={f.instruction}
              name="instruction"
              onChange={(val, name) => props.onUpdateField(index, val, name)}
              placeHolder="Введите содержание работ"
            />
          </FormField>
          <FormField label="Технические требования">
            <TextArea
              value={f.requirements}
              name="requirements"
              onChange={(val, name) => props.onUpdateField(index, val, name)}
              placeHolder="Введите требования к проведению работы"
            />
          </FormField>
        </div>
        <SeparateLine />
      </Fragment>
    ))
  }

  return (
    <>
      <FormField label="Наименование бланка ТО" required={true}>
        <TextInput value={props.blank.name} name="name" onChange={props.onChange} placeHolder="Введите наименование" />
      </FormField>
      <SeparateLine />
      {renderBlankFields()}
      <CreateEntityButton type="default" text="Добавить поле" fullWidth={true} onClick={props.onCreateField} />
    </>
  )
}

export default MaintenanceBlankForm
